import { type NavigateOptions, useNavigate, useSearchParams } from 'react-router-dom'

// Parameters to keep in the URL
const PARAMS_TO_KEEP = ['language', 'returnUrl']

const useNavigateWithParams = (): ((path: string, options?: NavigateOptions) => void) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const navigateWithParams = (path: string, options: NavigateOptions = {}): void => {
    // Filter the parameters we want to retain
    const paramsToKeep: Record<string, string> = {}
    for (const param of PARAMS_TO_KEEP) {
      const value = searchParams.get(param)
      if (value) {
        paramsToKeep[param] = value
      }
    }

    // Build the new URL with the retained parameters
    const url = new URL(path, window.location.origin)
    for (const [key, value] of Object.entries(paramsToKeep)) {
      // Only set if not already present in the path
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, value)
      }
    }

    // Navigate to the new URL
    navigate(`${url.pathname}${url.search}`, options)
  }
  return navigateWithParams
}

export default useNavigateWithParams
